<template>
    <div class="home">
        <div class="back-btn" @click="() => this.$router.push('/profile')"> &lt; 返回 </div>
        <tickets :ticket="ticket"></tickets>
        <div class="payStatus">
            <div class="title">
                <span>支付方式</span>
                <div v-if="ticket.payStatus===1">未支付</div>
                <div v-else>已支付</div>
            </div>
            <div class="payType">
                {{ticket.payType===4?'现场支付':ticket.payType===3?'转账':ticket.payType===2?"微信支付":ticket.payType===1?'支付宝支付':''}}
            </div>
            <p v-if="ticket.payType===4" class="tips">请于参会当日签到并缴纳会务费，支持现金、微信、支付宝。</p>
        </div>
    </div>
</template>
<script>
import Pay from '../../components/pay/index.vue'
import Tickets from '../../components/ticketsInfo/index.vue'
import Footer from '../../components/footer/index.vue'
import http from '@/utils/http'
import apis from '@/utils/apis'
export default {
    data() {
      return {
         ticket: {},
         payType: 2
      }
    },
    components: {
      Pay,
      Tickets,
      Footer
    },
    computed:{
        meetingId() {
            return this.$store.state.meetingId || localStorage.getItem('meetingId')
        }
    },
    methods: {
        getPayStatus(type) {
            this.payType = type
        },
        async getTicketInfo() {
            const params = {
                audienceId: localStorage.getItem('audienceId')
            }
            const res = await http.get(`${apis.getTicket}${this.meetingId}`, {params})
            if (res.code === 0) {
                this.ticket = res.ticketInfo
            }
            console.log(res)
        }
    },
    mounted() {
        // this.ticket = JSON.parse(localStorage.getItem('ticket'))
        // this.whiteDiscount = JSON.parse(localStorage.getItem('whiteDiscount')) || {}
        this.getTicketInfo()
    }
}
</script>
<style lang="stylus" scoped>
    .back-btn{
        color: #606060
        font-size 27px
        padding 10px
    }
    .home
        width 100%
        min-height 100vh
        background #f1f1f1
        box-sizing border-box
        padding-bottom 100px
    .mt
        margin-top 22px
    .payStatus
        padding 35px 22px 0px
        background #ffffff
        margin-top 30px
    .title
        color #333333
        padding-bottom 29px
        display flex
        justify-content space-between
        align-items center
        span
            font-size 32px
        div
            width 160px
            height 50px
            text-align center
            line-height 50px
            border-radius 25px
            font-size 30px
            background none
            border 1px solid #ccc
    .payType
        font-size 30px
        height 85px
        line-height 85px
        border-top 1px dashed rgba(199,199,199,1)
    .tips
        font-size 24px
        color #333
        padding-bottom 30px

    @media screen and (min-width: 800px)
        .back-btn{
            font-size 24px
            margin-bottom 20px
            margin-left 20px
        }
        .home
            width 900px
            margin 0 auto
            min-height 100vh
            background #f1f1f1
            box-sizing border-box
            padding-bottom 100px
        .mt
            margin-top 22px
        .payStatus
            padding 15px 22px 0px
            background #ffffff
            margin-top 30px
        .title
            color #333333
            padding-bottom 29px
            display flex
            justify-content space-between
            align-items center
            span
                font-size 24px
            div
                width 160px
                height 50px
                text-align center
                line-height 50px
                border-radius 25px
                font-size 24px
                background none
                border 1px solid #ccc
        .payType
            font-size 22px
            height 85px
            line-height 85px
            border-top 1px dashed rgba(199,199,199,1)
        .tips
            font-size 12px
            color #333
            padding-bottom 30px
</style>
